<template>
<div class="EditSSOConfigurationSSO">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="close-text-font-style margin-right-1Perc margin-Top-1Perc margin-bottom-5Perc cursor-pointer " v-on:click="updateHideCreateGroupOverlayFlag">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Client Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="clientName">
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Domain
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="domainName">
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Single SignonIdProvider Url
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="SSPUrl">
                        </div>
                    </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Authentication Mode
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                        <select class="form-control" v-model="authType">
                        <option value=-1 disabled>Select</option>
                        <option value=0>SP Initiated</option>
                        <option value=1>IDP Initiated</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Certificate
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                        <input type="file" id="certificate">
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left">
                  <a :href="prevCertificateLink">{{prevCertificateName}}</a>
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="UpdateSSO">Update</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import server from '@/utils/server'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { ssoConfigurationService } from '@/server-util/sso-configuration-service'
export default {
  props: ['selectedSSOConfigObj'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      clientName: '',
      domainName: '',
      SSPUrl: '',
      authType: -1,
      SSOConfigId: '',
      prevCertificateLink: '',
      prevCertificateName: '',
      isSSOCreatedSuccessfully: false
    }
  },
  name: 'EditSSOConfigurationSSO',
  methods: {
    setDefaultValues: function () {
      // console.log(' >>>> ' + JSON.stringify(this.getSSOConfigObj))
      this.SSOConfigId = this.getSSOConfigObj.SSOConfigId
      this.clientName = this.getSSOConfigObj.ClientName
      this.domainName = this.getSSOConfigObj.Domain
      this.SSPUrl = this.getSSOConfigObj.SingleSignonIdProviderUrl
      this.authType = this.getSSOConfigObj.AuthMode
      this.prevCertificateName = this.getSSOConfigObj.CertificateFileName
      this.prevCertificateLink = server.baseURL() + '/api/SSOConfig/GetCertificate?ssoConfigId=' + this.SSOConfigId
    },
    updateHideCreateGroupOverlayFlag: function () {
      var obj = {
        closeOverlay: false,
        refreshList: false
      }
      this.$emit('closeOverlay', obj)
    },
    UpdateSSO: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var certificate = document.getElementById('certificate').files[0]
        var storeObj = this.$store
        // var _this = this
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          this.$store.state.isLoading = true
          const formData = new FormData()
          formData.append('SSOConfigId', this.SSOConfigId)
          formData.append('ClientName', this.clientName)
          formData.append('Domain', this.domainName)
          formData.append('SingleSignonIdProviderUrl', this.SSPUrl)
          formData.append('AuthMode', this.authType)
          if (certificate !== undefined && certificate !== null) {
            formData.append('CertificateFile', certificate)
          }
          ssoConfigurationService
            .updateSSO(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                var obj = {
                  closeOverlay: false,
                  refreshList: true
                }
                this.$emit('closeOverlay', obj)
              } else {
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW SSO'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateDomainName: function () {
      if (/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(this.domainName)) {
        return true
      }
      return false
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.clientName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Client name can\'t be empty.'
        return false
      } else if (this.domainName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Domain name can\'t be empty.'
        return false
      } else if (!this.validateDomainName()) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid Domain name.'
        return false
      } else if (this.SSPUrl.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Single signonId provider url can\'t be empty.'
        return false
      } else if (this.authType === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select authentication type.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox
  },
  computed: {
    getSSOConfigObj: {
      get: function () {
        return this.selectedSSOConfigObj
      }
    }
  }
}
</script>

<style scoped>
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}
.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.overflow-x-hidden{
  overflow-x: hidden !important;
}
.font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
a:link {
    color: #0000FF;
    text-decoration: none;
} 
a:visited {
    color: #0000FF;
    text-decoration: none;
}
a:hover{
  color: #0000FF;
  text-decoration: underline;
}
a:active{
  color: #0000FF;
  text-decoration: none;
}
a{
    color: #0000FF !important;
    /* text-decoration: underline !important; */
}
</style>


// WEBPACK FOOTER //
// src/components/sso_configuration/EditSSOConfigurationOverlay.vue